const n = (e, r) => e && e.replace(/{([^}]+)?}/gm, (t, a) => r[a]);
export {
  n as default
};
